import request from "@/utils/request";

export default function agentDelMantenanceMan(params) {
    return request.post(
        `/user/maintenanceMan/agentDelMantenanceMan`, undefined, {
            params
        }
    )
}
